//TODO MOVE INTO CONSTANT FILE
const DEBUT = 'Début';
const FIN = 'Fin';
const NON_DEMARRE = 'Non-démarré';
const MI_TEMPS_1 = '1ère période';
const MI_TEMPS_2 = '2ème période';
const PROLONGATION = 'Prolongation';
const PERIODE_1 = '1ère prolongation';
const PERIODE_2 = '2ème prolongation';
const TIRS_AU_BUT = 'Tirs au but';
const TERMINE = 'Match terminé';

const TYPE_MAIN = 'main';
const TYPE_SUB = 'sub';
const TYPE_OTHER = 'other';

const COMPO_CONSTANTS = {
    BASKET: {name:'basket5',holdersNumber:5},
    HANDBALL: {name:'handball7',holdersNumber:7},
    SOCCER: {name:'442',holdersNumber:11},
    RUGBY: {name:'rugby15',holdersNumber:15}
};

/**
 * Model for Match's Period
 * @param {string} name : Period's name
 * @param {string} periodType : Period's type (/ex: main, sub)
 * @param {int} minDuration : Period's default duration in minutes at period's start
 * @param {boolean} isPlayable : is Period a playable or technical period in game (ex: playable period:1st Half, or technical period: 1st Half end)
 * @param {int} playedStepInGame : Period's step in game for Period played 
 * @param {int} matchPeriod : Period's step in match (all steps)
 * @param {int} periodPhase : Period's phase in game
 * 
 *  
 * 
 * Usage: 
 * - let firstHalf = new PeriodModel('1st Half', 45, true, false); --> period creation
 * - firstHalf.display(); --> Outputs the details of the period
 * - firstHalf.updatePeriod('1st Half Extended', 60, true, false); --> Updating the period information
 * 
 */
class PeriodModel {
    constructor(name, periodType, minDuration, isPlayable, playedStepInGame, matchPeriod, periodPhase) {
        this.name = name;
        this.minDuration = minDuration;
        this.isPlayable = isPlayable;
        this.playedStepInGame = playedStepInGame;
        this.periodType = periodType;
        this.matchPeriod = matchPeriod;
        this.periodPhase = periodPhase;
    }

    updatePeriod(name, periodType, minDuration, isPlayable, playedStepInGame, matchPeriod, periodPhase) {
        this.name = name;
        this.minDuration = minDuration;
        this.isPlayable = isPlayable;
        this.playedStepInGame = playedStepInGame;
        this.periodType = periodType;
        this.matchPeriod = matchPeriod;
        this.periodPhase = periodPhase;
    }

    display() {
        console.log(`Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}`);
    }
}


// DUPLICATION IN SERVER FOR NOW - into server/utils/rules/rules.js

// Default match position / composition for given discipline 
export class MatchComposition {
    constructor(discipline) {
        // Uppercase on discipline
        const upperDiscipline = discipline.toUpperCase();

        // Get compo with given uppercase discipline
        this.name = COMPO_CONSTANTS[upperDiscipline]?.name;
        this.holdersNumber = COMPO_CONSTANTS[upperDiscipline]?.holdersNumber;

        if (!this.composition) {
            throw new Error(`Composition non trouvée pour la discipline: ${discipline}`);
        }
    }
}

/**
 * Model for Match's Sheet (feuille de match)
 * @param {string} discipline : Match Sheet discipline
 * @param {string} provider : Match Sheet provider
 * @param {string} match : Match Sheet match (to fill: day, dateTime, homeTeam, awayTeam, homeCoach, awayCoach,
 *                          homeSubstitutes, awaySubstitutes, provider, discipline) 
 * @param {string} season : Match Sheet season
 * @param {string} homeComposition : Match Sheet composition for home team (if not filed, is default value for discipline)
 * @param {string} awayComposition : Match Sheet composition for away team (if not filed, is default value for discipline)
 */
export class MatchSheetModel {

    //Default basic match sheet model
    constructor(discipline, provider ) {

        const composition = new MatchComposition(discipline);

        this.competition = '';
        this.season = '';
        this.day = '';
        this.dateTime = new Date();
        this.homeTeam = '';
        this.homeCoach = '';
        this.awayCoach = '';
        this.homeComposition = composition.name;
        this.homeHolders = [];
        this.homeSubstitutes = [];
        this.awayTeam = '';
        this.awayComposition = composition.name;
        this.awayHolders = [];
        this.awaySubstitutes = [];
        this.provider = provider;
        this.discipline = discipline;
    }

    updateMatchSheet(match, season, homeComposition=null, awayComposition=null) {

        const composition = new MatchComposition(match.discipline);
        const homeCompo = homeComposition ? homeComposition : composition.name;
        const awayCompo = awayComposition ? awayComposition : composition.name;
        

        this.competition = match.competition;
        this.season = season;
        this.day = match.day;
        this.dateTime = match.dateTime;
        this.homeTeam = match.homeTeam._id;
        this.homeCoach = match.homeCoach;
        this.awayCoach = match.awayCoach;
        this.homeComposition = homeCompo;
        this.homeHolders = match.homeHolders?.length > 0 ? [...match.homeHolders] : this.homeHolders;
        this.homeSubstitutes = match.homeSubstitutes?.length > 0 ? [...match.homeSubstitutes] : this.homeSubstitutes;
        this.awayTeam = match.awayTeam._id;
        this.awayComposition = awayCompo;
        this.awayHolders = match.awayHolders?.length > 0 ? [...match.awayHolders] : this.awayHolders;
        this.awaySubstitutes = match.awaySubstitutes?.length > 0 ? [...match.awaySubstitutes] : this.awaySubstitutes;
        this.provider = match.provider;
        this.discipline = match.discipline;
    }
}

const rugbyRules = {
    periodDuration : {
        main : 40,
        sub : 10,
    },
    getMinTotalDuration : function(period){ 
        return period <= 2 ? 
            (period) * this.periodDuration.main : 
            2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub
    },
    getActualPeriodDuration : function(period){ 
        return period <= 2 ? 
            this.periodDuration.main : 
            this.periodDuration.sub
    },
    getTotalTimer : function(period, timer){
        const minutes = timer / 60;
        const totalMin = period <= 2 ? 
            period * this.periodDuration.main + minutes :
            2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub + minutes
        return totalMin * 60
    },
    getTimerList : function(period, maxTimer){
        const minTimer = period < 2 ? period * this.periodDuration.main : 2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub

        let timerList = []

        if(period === 2)
            timerList.push({id : 0, value : this.periodDuration.main * 2})
        else if(period === 5 || period === 6)
            timerList.push({id : 0, value : this.periodDuration.main * 2 + this.periodDuration.sub * 2})
        else
            for(var i = 0 ; i <= maxTimer ; i++){
                timerList.push({id : i, value : i + minTimer})
            }

        return timerList
    }
}

const soccerRules = {
    periodDuration : {
        main : 45,
        sub : 15,
    },
    getMinTotalDuration : function(period){ 
        return period <= 2 ? 
            (period) * this.periodDuration.main : 
            2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub
    },
    getActualPeriodDuration : function(period){ 
        return period <= 2 ? 
            this.periodDuration.main : 
            this.periodDuration.sub
    },
    getTotalTimer : function(period, timer){
        const minutes = timer / 60;
        const totalMin = period <= 2 ? 
            period * this.periodDuration.main + minutes :
            2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub + minutes
        return totalMin * 60
    },
    getTimerList : function(period, maxTimer){
        const minTimer = period < 2 ? period * this.periodDuration.main : 2 * this.periodDuration.main + (period - 3) * this.periodDuration.sub

        let timerList = []

        if(period === 2)
            timerList.push({id : 0, value : this.periodDuration.main * 2})
        else if(period === 5 || period === 6)
            timerList.push({id : 0, value : this.periodDuration.main * 2 + this.periodDuration.sub * 2})
        else
            for(var i = 0 ; i <= maxTimer ; i++){
                timerList.push({id : i, value : i + minTimer})
            }

        return timerList
    }
}

const basketRules = {
    periodDuration : {
        main : 10,
    },
    getMinTotalDuration : function(period){ 
        return period * this.periodDuration.main
    },
    getActualPeriodDuration : function(period){ 
        return this.periodDuration.main
    },
    getTotalTimer : function(period, timer){
        const minutes = timer / 60;
        const totalMin = period * this.periodDuration.main + minutes
        return totalMin * 60
    },
    getTimerList : function(period, maxTimer){
        const minTimer = period * this.periodDuration.main

        let timerList = []

        for(var i = 0 ; i <= maxTimer ; i++){
            timerList.push({id : i, value : i + minTimer})
        }

        return timerList
    }
}

const handballRules = {
    periodDuration: {
        main: 30,  // Principale : durée de chaque mi-temps (minutes)
        sub: 10, 
        other: 0   // Prolongations: durée de chaque
    },

    getHandballPeriods: function() {
        return new Map([
        // Period: ${this.name}, periodType: ${this.periodType}, minDuration: ${this.minDuration} minutes, isPlayable: ${this.isPlayable}, 
        //playedStepInGame: ${this.playedStepInGame} matchPeriod: ${this.matchPeriod}, periodPhase:${this.periodPhase}
        [0, new PeriodModel(NON_DEMARRE, TYPE_OTHER, 0, false, null,0,'start')],
        [1, new PeriodModel(MI_TEMPS_1, TYPE_MAIN, 0, true, 1, 1,'mt')],
        [2, new PeriodModel(FIN + ' ' + MI_TEMPS_1, TYPE_OTHER, this.periodDuration.main, false, null, 2,'mt_end')],
        [3, new PeriodModel(MI_TEMPS_2, TYPE_MAIN, this.periodDuration.main, true, 2, 3,'mt2')],
        [4, new PeriodModel(FIN + ' ' + MI_TEMPS_2, TYPE_OTHER, this.periodDuration.main * 2, false, null, 4,'mt2_end')],
        [5, new PeriodModel(PERIODE_1, TYPE_SUB, this.periodDuration.main * 2, true, 3, 5,'ot')],
        [6, new PeriodModel(FIN + ' ' + PERIODE_1, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub, false, null, 6,'ot_end')],
        [7, new PeriodModel(PERIODE_2, TYPE_SUB, this.periodDuration.main * 2 + this.periodDuration.sub, true, 4, 7,'ot2')],
        [8, new PeriodModel(FIN + PERIODE_2, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub * 2, false, null, 8,'ot2_end')],
        [9, new PeriodModel(TIRS_AU_BUT, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub * 2, true, 5, 9,'so')],
        [10, new PeriodModel(TERMINE, TYPE_OTHER, this.periodDuration.main * 2 + this.periodDuration.sub * 2, false, null, 10,'end')]
    ])},

    getMinTotalDuration: function(period){ 
       //TODO nullable
       return this.getHandballPeriods().get(period).minDuration;
    },
    getActualPeriodDuration: function(period){ 
        //TODO nullable
        let periodType = this.getHandballPeriods().get(period).periodType;
        let duration = this.periodDuration[periodType];
        return duration;
    },
    getTotalTimer: function(period, timer){
        // Temps total en secondes (avec timer en cours)
        const minutes = timer / 60;
        const totalMin = this.getMinTotalDuration(period) + minutes;
        return totalMin * 60;
    },
    getTimerList: function(period, maxTimer){
        // Génère une liste de valeurs de timer pour la période donnée
        let minTimer = this.getMinTotalDuration(period);

        let timerList = [];

        for(var i = 0; i <= maxTimer; i++){
            timerList.push({id: i, value: i + minTimer});
        }

        return timerList;
    },

    getPeriodByMatchStep: function(step){
        return this.getHandballPeriods().get(step);
    },

    getPeriodByType: function(type){
        //TODO nullable
        const periods = this.getHandballPeriods();

        for (const [key, periodModel] of periods) {
            if (periodModel.periodPhase === type) {
                return periodModel;
            }
        }
    },

    getPlayedGamesPeriods: function() {
        const allPeriods = this.getHandballPeriods();
        let playablePeriods = new Map();
    
        // Iterate over all periods and add the playable ones to the playablePeriods array
        for (const [key, periodModel] of allPeriods) {
            if (periodModel.isPlayable) {
                playablePeriods.set(key, periodModel);
            }
        }
    
        // Logging the count for debugging purpose
       // console.log('Playable Periods Count = ', playablePeriods.length);
    
        return playablePeriods;
    },

    getSurchagePeriod: function(currentPeriod) {

        const allPlayablePeriods = this.getPlayedGamesPeriods();
        const allPeriods = this.getHandballPeriods();

        if (allPeriods.get(currentPeriod).isPlayable){
            return allPeriods.get(currentPeriod);
        }

        for (const [key, value] of allPlayablePeriods) {
            if (key > currentPeriod) {
                return value;
                }
            }
        }

}



// COMMON LOGIC

const getMaxTotalDuration = (period, discipline) => {
    const rules = discipline === 'rugby' ? rugbyRules : soccerRules

    return period <= 2 ? (period + 1) * rules.periodDuration.main : 2 * rules.periodDuration.main + (period - 2) * rules.periodDuration.sub
}

const getMinTotalDuration = (period, discipline) => {
    switch(discipline){
        case 'soccer':
            return soccerRules.getMinTotalDuration(period)
        case 'rugby' : 
            return rugbyRules.getMinTotalDuration(period)
        case 'basket' :
            return basketRules.getMinTotalDuration(period)
        case 'handball':
            return handballRules.getMinTotalDuration(period)
        default:
            //console.error("Discipline non reconnue pour le calcul de la durée totale de temps");
            return 0;
    }
}

const getActualPeriodDuration = (period, discipline) => {
    switch(discipline){
        case 'soccer':
            return soccerRules.getActualPeriodDuration(period)
        case 'rugby' : 
            return rugbyRules.getActualPeriodDuration(period)
        case 'basket' :
            return basketRules.getActualPeriodDuration(period)
        case 'handball':
            return handballRules.getActualPeriodDuration(period);
        default:
            console.error("Discipline non reconnue pour le calcul du temps de la période courante");
            return 0;
    }
}

export const getTotalTimer = (period, timer, discipline) => {

    switch(discipline){
        case 'soccer':
            return soccerRules.getTotalTimer(period, timer)
        case 'rugby' : 
            return rugbyRules.getTotalTimer(period, timer)
        case 'basket' :
            return basketRules.getTotalTimer(period, timer)
        case 'handball':
            return handballRules.getTotalTimer(period, timer);
        default:
            console.error("Discipline non reconnue pour le timer");
            return 0;
    }
}

export const getTimerList = (period, maxTimer, discipline) => {

    switch(discipline){
        case 'soccer':
            return soccerRules.getTimerList(period, maxTimer)
        case 'rugby' : 
            return rugbyRules.getTimerList(period, maxTimer)
        case 'basket' :
            return basketRules.getTimerList(period, maxTimer)
        case 'handball':
            return handballRules.getTimerList(period, maxTimer);
        default:
            console.error("Discipline non reconnue pour le calcul de des durées de périodes");
            return [];
    }

}

export const getVisualTimer = (period, timer, discipline) => {

    const minTotalDuration = getMinTotalDuration(period, discipline)
    const actualPeriodDuration = getActualPeriodDuration(period, discipline)

    let leftPartTimer = Math.min(timer, actualPeriodDuration) + minTotalDuration

    let rightPartTimer = timer - leftPartTimer + minTotalDuration
    
    return rightPartTimer ? leftPartTimer+"'(+"+rightPartTimer+")" : leftPartTimer+"'"
}

export const getPeriod = (period, discipline) => {

    const errtxt = "Discipline non implémentée getPeriod pour :" + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getPeriodByMatchStep(period);
        default:
            console.error(errtxt);
            return [];
    }

}

export const getPeriodByType = (type, discipline) => {

    const errtxt = "Discipline non implémentée getPeriodByType pour :" + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getPeriodByType(type);
        default:
            console.error(errtxt);
            return [];
    }

}

export const getAllMatchPeriods = (discipline) => {

    const errtxt = "getAllMatchPeriods non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getHandballPeriods();
        default:
            console.error("getAllMatchPeriods discipline non reconnue: " + discipline);
            return [];
    }

}

export const getPlayedGamesPeriods = (discipline) => {

    const errtxt = "getPlayedGamesPeriods non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getPlayedGamesPeriods();
        default:
            console.error("getPlayedGamesPeriods discipline non reconnue: " + discipline);
            return [];
    }

}

export const getSurchargePeriod = (discipline, currentPeriod) => {

    const errtxt = "getSurchargePeriod non implémentée pour: " + discipline;

    switch(discipline){
        case 'soccer':
            console.error(errtxt);
            return 
        case 'rugby' : 
            console.error(errtxt);
            return 
        case 'basket' :
            console.error(errtxt);
            return 
        case 'handball':
            return handballRules.getSurchagePeriod(currentPeriod)?.matchPeriod;
        default:
            console.error("getSurchargePeriod discipline non reconnue: " + discipline);
            return [];
    }
    
}



